import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawTextInput, type RawTextInputProps } from './RawTextInput'

export type TextInputProps = RawTextInputProps & InputProps

export const TextInput = ({
  wrapperProps,
  ref,
  ...fieldProps
}: TextInputProps) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawTextInput {...fieldProps} id={id} ref={ref} />
    </InputWrapper>
  )
}
